import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PraiseReviewContent } from '@/features/wizard/components/PraiseReviewContent';

export const Route = createFileRoute('/_dashboard/interactions/praise/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate({ to: '/' });
  };

  return <PraiseReviewContent praiseId={id} onBack={handleBack} />;
}
